import React from 'react';
import PropTypes from 'prop-types';
import Notification from '@tds/core-notification';
import RichText from '../richText';

const ErrorMessage = ({ type, text, data, options, isError }) => {
  return (isError &&
    <div style={{ margin: '1em 0', width: '100%' }}>
      <Notification variant="error" copy="en">
        {type === 'richText' ? (
          <RichText data={data} options={options} />
        ) : (
          <p>{text}</p>
        )}
      </Notification>
    </div>
  );
};

ErrorMessage.propTypes = {
  type: PropTypes.string,
  text: PropTypes.string,
  data: PropTypes.shape({
    content: PropTypes.arrayOf(PropTypes.object).isRequired
  }).isRequired,
  options: PropTypes.shape({
    renderMark: PropTypes.object,
    renderNode: PropTypes.object
  }),
  isError: PropTypes.bool
};

ErrorMessage.defaultProps = {
  type: 'text',
  text: '',
  options: {
    renderMark: {},
    renderNode: {}
  }
};

export default ErrorMessage;
